import type { ComponentType, SvelteComponent } from 'svelte';

import BooleanIcon from '../BooleanIcon.svelte';
import RelativeDate from '../RelativeDate.svelte';

import type { CellType, BuiltInCellType } from './table-types';

type AnyComponent = ComponentType<SvelteComponent>;

export type CellRenderer = {
  component: AnyComponent;
  getProps: (value: unknown, row: Record<string, unknown>) => Record<string, unknown>;
};

export const mergeCellRenderers = (custom: Record<string, CellRenderer> = {}): Record<CellType, CellRenderer> => ({
  ...CELL_RENDERERS,
  ...custom,
});

export const CELL_RENDERERS: Record<BuiltInCellType, CellRenderer> = {
  relativeDate: {
    component: RelativeDate as unknown as AnyComponent,
    getProps: (value) => ({ date: new Date(value as string) }),
  },
  boolean: {
    component: BooleanIcon as unknown as AnyComponent,
    getProps: (value) => ({ value }),
  },
};
